var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComponent571(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_57_1",
    "data-name": "Component 57 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "whatsapp",
    d: "M18.027,3.039A10.363,10.363,0,0,0,1.72,15.54L.25,20.909l5.493-1.441a10.35,10.35,0,0,0,4.951,1.261h0A10.365,10.365,0,0,0,18.027,3.039ZM10.7,18.98h0a8.6,8.6,0,0,1-4.383-1.2L6,17.593l-3.259.855.87-3.178-.2-.326a8.612,8.612,0,1,1,7.3,4.036Zm4.724-6.45c-.259-.13-1.532-.756-1.769-.842s-.41-.129-.582.13-.669.842-.82,1.015-.3.194-.561.065a7.071,7.071,0,0,1-2.082-1.285,7.809,7.809,0,0,1-1.44-1.793c-.151-.259,0-.386.114-.528A7.323,7.323,0,0,0,8.928,8.4a.476.476,0,0,0-.022-.454c-.065-.13-.582-1.4-.8-1.922s-.424-.436-.583-.444-.324-.009-.5-.009a.951.951,0,0,0-.69.324,2.9,2.9,0,0,0-.906,2.16A5.036,5.036,0,0,0,6.49,10.737a11.54,11.54,0,0,0,4.423,3.909,14.818,14.818,0,0,0,1.476.545,3.549,3.549,0,0,0,1.631.1,2.667,2.667,0,0,0,1.747-1.231,2.163,2.163,0,0,0,.151-1.231c-.065-.108-.237-.173-.5-.3Zm0,0",
    transform: "translate(11.879 12)",
    fill: "#003a6f",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent571);
export default __webpack_public_path__ + "static/media/Component 57 – 1.9565c0bdf8a2334640db588f8afbff42.svg";
export { ForwardRef as ReactComponent };